import { COUPON_STATUS } from "@/constants/coupon";
import { getActivity, getCounpons, getGrocery } from "@/services";
import ModalWrap from "../HBModal/ModalWrap";
import AuthExtendDialog from "./authExtendDialog";
import BuyDialog from "./buyDialog";
import ExpVipDialog from "./expVip";
import IncreateTimesDialog from "./increateTimesDialog";
import OrderPay from "./orderPay";
// import ExpVipExpired from "./expVip/expiredDialog";
import orderCheck from "./shared/orderCheck";
// import VipExpired from "./buyDialog/expiredDialog";
import { isBigCompanyByUser, isSingleVipByUser } from "@/constants/vip";
import useAppStore from "@/context/store";
import { getExpsValue } from "@/tracker/abTest";
import { PRESETS_CONDITION, stewardInstance } from "@/utils/steward";
import HBAlert from "../HBModal/alert";
import AddSubjectCert from "./addSubjectCert";
import PayRetentionModal from "./payRetention";
import CancelConfirmModal from "./payRetention/confirm";
import PaySuccessModal from "./paySucess";
/**
 * 弹窗前做一些检查
 * @template T
 * @param {T} Dialog
 * @returns {T}
 */
const beforeOpenCheck = (Dialog) => {
  const oldOpen = Dialog.open;

  Dialog.open = async function (...args) {
    try {
      const { user } = useAppStore.getState();

      // 大企业用户不弹购买弹窗
      if (isBigCompanyByUser(user)) {
        return;
      }

      await orderCheck();
      oldOpen(...args);
    } catch (error) {
      console.error(error);
    }
  };

  return Dialog;
};

const checkCondition = async (activityCode) => {
  if (!activityCode) {
    return false;
  }
  const activityResult = await getActivity({ activity_code: activityCode });
  const couponResult = await getCounpons({
    coupon_id:
      activityResult?.detail?.coupons?.map((coupon) => coupon?.id).join(",") ||
      "",
    page_num: 1,
    // 计算每张券最多能领取的数量然后加起来
    page_size: activityResult?.detail?.coupons?.reduce((result, coupon) => {
      result += coupon?.user_take_num_limit || 0;
      return result;
    }, 0),
  });
  if (!couponResult?.err) {
    // 判断优惠券中是否有已经使用或者 未过期的优惠券
    const result = couponResult?.list?.some((item) => {
      return [COUPON_STATUS.GOT, COUPON_STATUS.USED].includes(item.status);
    });
    return !result;
  } else {
    return false;
  }
};

// 会员新购买弹框
export const BuyVipDialog = beforeOpenCheck(ModalWrap(BuyDialog));
// 增加下载次数弹框
export const AdditionGoodDialog = beforeOpenCheck(
  ModalWrap(IncreateTimesDialog)
);
// 扩展授权弹框
export const VipAuthDialog = beforeOpenCheck(ModalWrap(AuthExtendDialog));
/**增加授权主体弹窗 */
export const AddSubjectCertDialog = beforeOpenCheck(ModalWrap(AddSubjectCert));
// 继续支付弹框
export const OrderPayDialog = ModalWrap(OrderPay);
// 体验会员购买弹框
export const BuyExpVipDialog = ModalWrap(ExpVipDialog);

BuyVipDialog.oldOpen = BuyVipDialog.open;
BuyVipDialog.open = async function (props = {}) {
  try {
    const oldOnFinish = props.onFinish;

    props.onFinish = async (...param) => {
      oldOnFinish && oldOnFinish(...param);
    };

    const user = await useAppStore.getState().refreshUser();

    if (isSingleVipByUser(user)) {
      HBAlert.open({
        title: "无法购买",
        content: "您正在使用花瓣素材模板VIP，暂时无法更换VIP套餐",
      });
      return;
    }

    let oldFn = props.onAborted;
    props.onAborted = async () => {
      // https://grocery.huaban.com/put/131
      const config = await getGrocery("pay-retention-good");
      const CloseKey = `BuyVipDialogCloseTimes_${user.user_id}`;
      const ExpVipTimeKey = `ExpVipDisplayTimeKey_${user.user_id}`;
      // const HasSendCounponKey = `HasSendCounponKey_${user.user_id}`;
      // 触发条件（弹窗关闭次数）
      const triggerTimes = +config?.triggerTimes || 2;
      // 体验会员弹出后几天后可以再弹出
      const expireDays = +config?.expVipDisplayTime || 1;

      // 获取支付挽留策略
      const pay_retention_strategy = await getExpsValue(
        config?.abtest,
        config?.default || "coupon_10"
      );
      const closeTimes = +localStorage.getItem(CloseKey) || 0;
      // 匹配的策略
      const match_strategy = config.list.find(
        (s) => s.unique == pay_retention_strategy
      );
      switch (match_strategy?.type) {
        // 优惠券策略
        case "coupon":
          // 支付挽留送券，活动code
          // 如果会员未到期，则不往下执行
          if (user.extra?.material_vip > 0) {
            break;
          }
          const activityCode = match_strategy?.newPayRetentionCouponCode;
          stewardInstance.trigerAwaitInit(
            PRESETS_CONDITION.TODAY_CLOSE_PAY_DIALOG_TIMES,
            {
              checkCondition: checkCondition,
              onOk: () => BuyVipDialog.oldOpen(props),
              activityCode,
            }
          );

          break;
        // 体验会员策略
        case "exp": {
          // 没买过任何会员，才触发
          // 体验会员弹框过期时间，超过这个时间才可继续展示
          if (!user.extra?.material_vip) {
            const expireTime =
              (+localStorage.getItem(ExpVipTimeKey) || 0) +
              expireDays * 24 * 3600 * 1000;

            // 控制体验会员展示条件
            if (triggerTimes > closeTimes + 1 || expireTime > Date.now()) {
              localStorage.setItem(CloseKey, closeTimes + 1);
              oldFn && oldFn();
            } else {
              localStorage.setItem(ExpVipTimeKey, Date.now());
              BuyExpVipDialog.open({
                ...props,
                onAborted: oldFn,
              });
            }
          }

          break;
        }
        // 推荐商品策略
        case "good":
          // 没买过任何会员，才触发
          // 体验会员弹框过期时间，超过这个时间才可继续展示
          if (!user.extra?.material_vip) {
            const expireTime =
              (+localStorage.getItem(ExpVipTimeKey) || 0) +
              expireDays * 24 * 3600 * 1000;

            // 控制体验会员展示条件
            if (triggerTimes > closeTimes + 1 || expireTime > Date.now()) {
              localStorage.setItem(CloseKey, closeTimes + 1);
              oldFn && oldFn();
            } else {
              localStorage.setItem(ExpVipTimeKey, Date.now());
              const openPayRetentionModal = () => {
                PayRetentionModal.open({
                  config: match_strategy,
                  onOk: async (order) => {
                    useAppStore.getState().refreshVips();
                    PaySuccessModal.open({
                      order,
                    });
                  },
                  onCancel: () => {
                    CancelConfirmModal.open({
                      onOk() {
                        openPayRetentionModal();
                      },
                    });
                  },
                });
              };
              openPayRetentionModal();
            }
          }

          break;

        // 无操作
        default:
          break;
      }
    };

    BuyVipDialog.oldOpen(props);
  } catch (error) {
    console.error(error);
  }
};
